import { Box } from '@components/Box';
import { styled } from '@styledComponents';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import Carousel from 'nuka-carousel';
import { themeColor, themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const SiteToSeeSectionDesktopWrapper = styled(Box)`
  display: block;
  width: 100%;
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const SiteToSeeSectionMobileWrapper = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const VideoContentWrapper = styled(Box)`
  width: 100%;
  height: 500px;
  text-align: center;
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const SiteToSeeContainer = styled(Box)`
  width: 100%;
  text-align: center;
`;

export const DesignImagesWrapper = styled(Flex)`
  width: 60%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    width: 95%;
  }
`;
export const VideoContainer = styled.div`
  position: relative;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 675px;
`;

export const VimeoWrapper = styled.div`
  width: 102%;
  outline: none;
  top: -2px;
  position: relative;
  margin-left: -9px;
  height: 103%;
`;

export const VideoWrapper = styled.div`
  position: absolute;
  z-index: 2;
  overflow: hidden;
  width: 675px;
  height: 420px;
  border-radius: 10px;
  border: 3px solid white;
  background: white;
  box-shadow: rgb(68 50 93 / 25%) 0px 30px 60px -12px, rgb(0 0 0 / 30%) 0px 18px 36px -18px;
`;

export const SiteTemplateFrame = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 2px solid white;
  border-radius: 10px;
  box-shadow: 0px 30px 60px -12px rgb(68 50 93 / 25%), 0px 18px 36px -18px rgb(0 0 0 / 30%);
  > svg {
    position: absolute;
    left: 7px;
    top: 6px;
    color: white;
  }
`;

export const BgLeftPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: absolute;
  z-index: 1;
  right: 910px;
  top: 60px;
`;

export const FrameLeftPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: absolute;
  z-index: 1;
  top: 103px;
  left: -198px;
`;

export const BgRightPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: absolute;
  z-index: 1;
  left: 870px;
  top: 138px;
`;

export const FrameRightPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  position: absolute;
  z-index: 1;
  top: -43px;
  left: 535px;
`;

export const SitePlaceholderCloudImage = styled(PlaceholderCloudImage)``;

export const StyledTitle = styled(Text)`
  width: 516px;
  margin-left: auto;
  margin-right: auto;
`;

/* ------- Mobile version --------*/

export const SiteToSeeWrapperMobileContainer = styled(Box)``;

export const StyledMobileImageWrapper = styled(Box)`
  width: 70%;
  height: auto;
  margin: ${themeSpace(0)} auto;
`;

export const WhatToSiteContainerMobile = styled.div`
  width: 329px;
  margin: auto;
  padding-top: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    p {
      width: 329px;
    }
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      width: 205px;
    }
    .text-pairing-body {
      width: 213px;
    }
  }
`;

export const StyledCarousel = styled(Carousel)<{ selectedSlide: number }>`
  padding-top: ${themeSpace(8)};
  padding-bottom: ${themeSpace(10)};
  .slider-list,
  .slider-slide {
    cursor: default !important;
    outline: none !important;
  }
  .slider-slide {
    overflow-y: auto;
    height: auto !important;
  }

  ul > li:nth-child(${props => props.selectedSlide + 1}) {
    z-index: -1 !important;
  }
  .slider-control-bottomcenter {
    left: 50% !important;
  }
  .paging-item {
    button {
      margin: 0 4px !important;
      opacity: 1 !important;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      fill: transparent !important;
      border: 2px solid ${themeColor('blue5')} !important;
    }
    &.active {
      button {
        background: ${themeColor('blue5')} !important;
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-left: ${themeSpace(10)};
`;

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    width: 100%;
    height: auto;
    min-height: 269px;
  }
`;

export const StyledTextPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: auto;
    min-height: 109px;
  }
`;

export const StyledCarouselPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 105% !important;
  height: auto;
  ${themeMediaQuery('below_sm')} {
    min-height: 191px;
  }
`;

export const StyledDotIndicator = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: left;
  bottom: ${themeSpace(7)};
`;

export const StyledCarouselDot = styled.div<{ isActive?: boolean }>`
  cursor: pointer;
  height: 12px;
  width: 12px;
  background: ${props => (props.isActive ? themeColor('newPurple5') : 'transparent')};
  border: 2px solid transparent;
  border-color: ${props => (props.isActive ? 'transparent' : themeColor('newPurple5'))};
  border-radius: 50%;
  margin-right: 20px;
`;
